/**
 * La pantalla de Configuración: los parámetros del negocio.
 *
 * Cada uno viene con su valor por defecto ya puesto, así que el sistema se
 * puede usar el primer día sin tocar nada. Esta pantalla es para cuando el
 * dueño quiera cambiar alguno.
 *
 * Sólo el dueño puede guardar: estos parámetros definen cómo se calcula la
 * plata. La API lo verifica igual, no alcanza con ocultar el botón.
 */

function alerta(tipo, texto) {
  const simbolos = { critico: '!', aviso: '!', bien: '✓' };
  const div = document.createElement('div');
  div.className = `alerta ${tipo}`;
  div.setAttribute('role', tipo === 'critico' ? 'alert' : 'status');
  div.innerHTML = `<span class="simbolo" aria-hidden="true">${simbolos[tipo] ?? '·'}</span><span></span>`;
  div.lastElementChild.textContent = texto;
  return div;
}

export async function pantallaDeConfiguracion(contenedor, { pedir, rol }) {
  const r = await pedir('/api/configuracion');
  if (!r.ok) {
    contenedor.appendChild(alerta('critico', r.cuerpo?.error ?? 'No se pudo traer la configuración.'));
    return;
  }
  const { valores, definiciones } = r.cuerpo;
  const puedeGuardar = rol === 'dueno';

  if (!puedeGuardar) {
    contenedor.appendChild(alerta('aviso',
      'Podés ver la configuración pero no cambiarla: estos parámetros definen cómo se ' +
      'calcula la plata y sólo los toca el dueño.'));
  }

  const avisos = document.createElement('div');
  contenedor.appendChild(avisos);

  const campos = Object.entries(definiciones).map(([clave, def]) => {
    const valor = valores[clave] ?? '';
    const id = `cfg-${clave}`;
    const deshabilitado = puedeGuardar ? '' : 'disabled';
    if (def.tipo === 'opcion') {
      const opts = (def.opciones ?? []).map((o) =>
        `<option value="${o}" ${valor === o ? 'selected' : ''}>${o.replace(/_/g, ' ')}</option>`).join('');
      return `<div class="campo">
        <label for="${id}">${def.rotulo}</label>
        <select id="${id}" name="${clave}" ${deshabilitado}>${opts}</select>
        <div class="ayuda">${def.ayuda}</div></div>`;
    }
    // Los porcentajes se muestran con dos decimales, sin los cuatro internos.
    const mostrado = def.tipo === 'porcentaje' && valor
      ? String(Number(valor).toFixed(2)) : valor;
    return `<div class="campo">
      <label for="${id}">${def.rotulo}</label>
      <input type="text" id="${id}" name="${clave}" value="${mostrado}" ${deshabilitado}>
      <div class="ayuda">${def.ayuda}</div></div>`;
  }).join('');

  const tarjeta = document.createElement('div');
  tarjeta.className = 'tarjeta';
  tarjeta.innerHTML = `
    <div data-rol="errores"></div>
    <form method="post" action="/api/configuracion" novalidate>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:0 20px">
        ${campos}
      </div>
      ${puedeGuardar
        ? '<div style="margin-top:16px"><button type="submit" class="boton principal">Guardar cambios</button></div>'
        : ''}
    </form>`;
  contenedor.appendChild(tarjeta);

  if (!puedeGuardar) return;

  tarjeta.querySelector('form').addEventListener('submit', async (evento) => {
    evento.preventDefault();
    const cajaErrores = tarjeta.querySelector('[data-rol="errores"]');
    cajaErrores.innerHTML = '';
    const datos = {};
    for (const clave of Object.keys(definiciones)) {
      const control = evento.target.elements[clave];
      if (control) datos[clave] = control.value;
    }
    const guardado = await pedir('/api/configuracion',
      { method: 'PUT', body: JSON.stringify(datos) });
    if (guardado.ok) {
      avisos.innerHTML = '';
      avisos.appendChild(alerta('bien', 'Configuración guardada.'));
      setTimeout(() => { avisos.innerHTML = ''; }, 4000);
      return;
    }
    if (guardado.cuerpo?.errores) {
      for (const e of guardado.cuerpo.errores) {
        cajaErrores.appendChild(alerta('critico', `${e.rotulo}: ${e.problema}`));
      }
    } else {
      cajaErrores.appendChild(alerta('critico', guardado.cuerpo?.error ?? 'No se pudo guardar.'));
    }
  });
}
